import i18next from 'i18next'
import { LangNames } from './LangService'

declare const module: NodeModule & {
	hot?: { accept(dependencies: string[], callback: () => void): void }
}

const loaders: Record<LangNames, () => Promise<{ default: object }>> = {
	[LangNames.RU]: () => import('./ru/restRu'),
	[LangNames.EN]: () => import('./en/restEn'),
}

const started: Partial<Record<LangNames, Promise<void>>> = {}

function getActiveLang(): LangNames {
	return i18next.language === LangNames.EN ? LangNames.EN : LangNames.RU
}

function loadLang(lang: LangNames): Promise<void> {
	if (!started[lang]) {
		started[lang] = loaders[lang]().then((module) => {
			i18next.addResourceBundle(
				lang,
				'translation',
				module.default,
				true,
				true
			)
		})
	}

	return started[lang] as Promise<void>
}

/**
 * Догружает основную часть словаря. Каждый язык загружается один раз,
 * повторные вызовы возвращают тот же промис.
 *
 * Русский нужен всегда: он указан в fallbackLng и подставляется вместо
 * ключей, которых нет в английском словаре.
 */
export default function loadRestTranslations(
	lang: LangNames = getActiveLang()
): Promise<void> {
	const jobs = [loadLang(LangNames.RU)]

	if (lang !== LangNames.RU) {
		jobs.push(loadLang(lang))
	}

	return Promise.all(jobs).then(() => undefined)
}

// Refresh i18next's resource store when lazy dictionaries change during development.
if (module.hot) {
	void loadRestTranslations()
	module.hot.accept(['./ru/restRu', './en/restEn'], () => {
		delete started[LangNames.RU]
		delete started[LangNames.EN]
		void loadRestTranslations()
	})
}
